import React, { useEffect, useState } from "react";
import { CALENDLY_URL } from "@/data/constants";

/**
 * Floating "Book your Demo Call" sticky CTA.
 * Auto-hides when the user is inside #pricing — each pricing card has its own
 * Calendly CTA, so the floating button is redundant there and would otherwise
 * overlap the Lead Generation card's content.
 */
export default function StickyAuditCTA() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const section = document.getElementById("pricing");
    if (!section || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      ([entry]) => {
        const inPricing = entry.isIntersecting;
        setHidden(inPricing);
        // Lets the chat widget's shadow CSS tuck its greeting away over pricing.
        document.documentElement.toggleAttribute("data-fbad-pricing", inPricing);
        document.querySelector("chat-widget")?.toggleAttribute("data-fbad-pricing", inPricing);
      },
      { threshold: 0.05 },
    );
    io.observe(section);
    return () => io.disconnect();
  }, []);

  return (
    <div
      className={`sticky-audit transition-opacity duration-300 ${hidden ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      aria-hidden={hidden}
    >
      <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="btn-primary shadow-2xl" data-testid="sticky-demo-cta">
        Book your Demo Call
      </a>
    </div>
  );
}
